import React from 'react';
import { Col, Row, Image, Button, } from 'react-bootstrap';
import ADD from '../../assets/images/ic-add.svg';
import EmptyRow from '../emptyRow/EmptyRow';
import TextField from '../textField/TextField';


const VideoData = () => {
    return (
        <>
                    <Row style={styles.divGrey}>
                        <Col lg={3}>                        
                        <input style={styles.checkb} type="radio" name="videobutton" required />{" "}
                         Upload Video 
                        </Col>
                        <Col lg={3}>
                        <input style={styles.checkb} type="radio" name="videobutton" required />{" "}
                           Paste Link
                        </Col>
                        <Col lg={6}>
                        <a href="#v"><span style={styles.add}><Image src={ADD} />  ADD VIDEO  </span></a>
                        </Col>
                    </Row>
                      
                                <div className="expando" id="v">
                                  <Row style={styles.divGrey}>
                                            <Row>
                                            <Col sm={4}>
                                            <TextField type="text" id="username" label="Title" placeholder="Youtube"/>
                                            </Col>
                                            
                                            <Col sm={4}>
                                            <TextField type="file" id="username" label="Link" placeholder="Enter Video Link"/>
                                            </Col>
                                            <Col sm={4}>
                                            <TextField type="file" id="username" label="Thumbnail" placeholder="Enter Video Thumbnail"/>
                                            </Col>
                                            </Row>
                                    </Row>                                    
                                    <Row style={styles.divGrey}>
                                            <Col sm={12}>
                                            <div style={styles.add}>    
                                            <Button style={styles.button}>Save</Button>
                                            </div>
                                            </Col>
                                    </Row>
                                    </div>
                      
                           
                      
        </>
    );
}

const styles: any = {
    divGrey: {
        backgroundColor: "#faf9f9",
        paddingTop: "20px",
        margin:"0px",        
        paddingLeft: "10px",
        paddingRight: "10px",       
      
      },

    id: {
        fontFamily: "Saira",
        fontSize: "12px",
        fontWeight: "500",
        color: "#242424",
    },
    idmob: {
        fontFamily: "Saira",
        fontSize: "12px",
        fontWeight: "600",
        color: "#e31837",
        border: "solid 2px #e31837",
        height: "30px",
        width: "30px",
        textAlign: "center",
        borderRadius: "15px",
        lineHeight: "2.2",
    },
    heading: {
        fontFamily: "Saira",
        fontSize: "14px",
        fontWeight: "600",
        color: "black",
        marginBottom: "4px",
    },
    data: {
        fontFamily: "Saira",
        fontSize: "12px",
        fontWeight: "500",
        color: "black",
    },
    add: {
        fontFamily: "Saira",
        fontSize: "12px",
        fontWeight: "600",
        color: "#e31837",
        float: "right",
    },
    text1: {
        fontFamily: "Saira",
      fontSize: "16px",
      fontWeight: "normal",
      border: "solid 1px #e4e4e4",
      borderTop: "0px",
      borderLeft: "0px",
      borderRight: "0px",
      color: "#6d6e71",
      textAlign: "center",
    },
    line: {
        height: "1px",
        margin: "0px",
        backgroundColor: "#ededed",
    },
    button: {
    padding: "13px 40px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: 400,
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#e31837",
    letterSpacing: "normal",
    border: "0px",
    float: "right",
  },
  };

export default VideoData;